import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const Hero = ({ title, subtitle, image, children, isSubpage = false }) => {
  const { t } = useLanguage();

  return (
    <section className={`relative ${isSubpage ? 'h-[350px] pt-32' : 'min-h-[85vh] pt-20'} flex items-center overflow-hidden bg-slate-900`}>
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={image || 'https://assets.auxodev.dk/assets/488e7d70-fe21-4956-bd96-e0986a28cf0b/f6e8c93a-1cbe-41fb-a9b7-dbfd7d3ade1b.jpg'} 
          alt="Hero background" 
          className={`w-full h-full object-cover ${isSubpage ? 'opacity-30' : 'opacity-40'} grayscale-[0.5]`}
        />
        <div className={`absolute inset-0 bg-gradient-to-r ${isSubpage ? 'from-slate-950/90 via-slate-950/70 to-slate-950/50' : 'from-slate-950 via-slate-950/80 to-transparent'}`} />
      </div>

      {/* Technical Background Pattern */}
      <div className="absolute inset-0 z-0 opacity-[0.05] pointer-events-none">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl">
          <div className={`animate-in fade-in slide-in-from-bottom-4 duration-700 relative ${isSubpage ? 'top-4' : '-top-12'}`}>
            <h1 className={`${isSubpage ? 'text-3xl md:text-5xl' : 'text-4xl md:text-7xl'} font-bold text-white mb-4 tracking-tight leading-tight`}>
              {t(title)}
            </h1>
            {subtitle && !isSubpage && (
              <p className="text-xl md:text-2xl text-slate-300 mb-10 leading-relaxed max-w-2xl">
                {t(subtitle)}
              </p>
            )}
            {subtitle && isSubpage && (
              <p className="text-lg text-slate-300 mb-0 leading-relaxed max-w-2xl">
                {t(subtitle)}
              </p>
            )}
            <div className="flex flex-wrap gap-4">
              {children}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom accent */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-slate-950/50 to-transparent z-0"></div>
    </section>
  );
};

export default Hero;
